import type { FC } from "react";

import { Modal } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { contactUsModalConfig } from "app/pages/sales-intelligence/common-components/ContactUsModal/configs";
import ModalContent from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/ModalContent";

interface PremiumFeatureContactUsModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const PremiumFeatureContactUsModal: FC<PremiumFeatureContactUsModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal
            isOpen={isOpen}
            customStyles={contactUsModalConfig}
            onRequestClose={onClose}
        >
            <Modal.CloseButton onClick={onClose} />
            <ModalContent
                title={translate("hook_modal.get_feature.success.title")}
                subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                buttonText={translate("si.modal.get_feature.success.btn.close")}
                onClick={onClose}
            />
        </Modal>
    );
};
